import { render, staticRenderFns } from "./StudentFilledForm.vue?vue&type=template&id=b20b7966&"
import script from "./StudentFilledForm.vue?vue&type=script&lang=ts&"
export * from "./StudentFilledForm.vue?vue&type=script&lang=ts&"
import style0 from "./StudentFilledForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports